import { createContext, useContext } from 'react';

export const JsmPlaygroundDemoLayerContext = createContext<HTMLElement | null>(null);

export const useJsmPlaygroundDemoLayer = () => useContext(JsmPlaygroundDemoLayerContext);
